import { render } from "./ObjectiveTree.vue?vue&type=template&id=4a5fb6c0&scoped=true"
import script from "./ObjectiveTree.vue?vue&type=script&lang=js"
export * from "./ObjectiveTree.vue?vue&type=script&lang=js"

import "./ObjectiveTree.vue?vue&type=style&index=0&id=4a5fb6c0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a5fb6c0"]])

export default __exports__